import { Box, Divider, IconButton, LinearProgress, Typography } from "@mui/material";
import { OpenInNew } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { Wysiwyg } from "../../../../components/wysiwyg/Wysiwyg";
import { ColoredLabelChip } from "../../../../components/chips/ColoredLabelChip";
import { Comments } from "../../../../components/comments/Comments";
import { TasksDetailViewFields } from "../../../../components/tasks/TasksDetail";
import { useFields } from "../../../../api/useFields";
import { useRecord } from "../../../../api/useRecord";
import type { LogbookTaskTimelineItem } from "../../types";

const TASK_FIELDS = "id,content,status,due_date,date_created,user_created.id,user_created.first_name,user_created.last_name,user_created.avatar,assigned_users.directus_users_id.id,assigned_users.directus_users_id.first_name,assigned_users.directus_users_id.last_name,assigned_users.directus_users_id.avatar,participant_users.directus_users_id.id,participant_users.directus_users_id.first_name,participant_users.directus_users_id.last_name,participant_users.directus_users_id.avatar,comments.id,comments.content,comments.user_created.*,comments.date_created,comments.date_updated";

type TaskDetailPanelProps = {
	task: LogbookTaskTimelineItem;
	treatmentId: string | number;
};

export const TaskDetailPanel = ({ task, treatmentId }: TaskDetailPanelProps) => {
	const { formatedFields, status: fieldsStatus } = useFields("tasks");
	const initialData = { item: task, id: task.id, entity: "tasks" };
	const { data: taskData } = useRecord("tasks", TASK_FIELDS, task.id, { initialData });

	const fullTask = taskData?.item ?? task;
	const isDone = fullTask.status === "done";

	if (fieldsStatus === "loading") return <LinearProgress />;
	if (fieldsStatus === "error") return <Typography>Tarefa não foi carregada.</Typography>;

	return (
		<Box>
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 1 }}>
				<Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
					<Typography variant="subtitle1" fontWeight="bold" color="primary">
						Tarefa
					</Typography>
					<ColoredLabelChip
						label={isDone ? "Concluída" : "Aberta"}
						color={isDone ? "#4BC417" : "#1A7FEA"}
					/>
				</Box>
				<IconButton
					color="secondary"
					component={Link}
					to={`/tasks/${task.id}/detail`}
					target="_blank"
					size="small"
				>
					<OpenInNew />
				</IconButton>
			</Box>
			<Box sx={{ mx: 2, px: 2 }}>
				<TasksDetailViewFields task={fullTask} taskFormatedFields={formatedFields} options={{ isSideView: true, showAssociated: false }} />
				<Divider sx={{ my: 4 }} />
				<Wysiwyg
					initialValue={fullTask.content || ""}
					isDisabled={true}
				/>
				{fullTask.comments?.length > 0 && (
					<Box sx={{ mt: 3 }}>
						<Comments
							comments={fullTask.comments}
							commentsEntity="task_comments"
							relatedEntityField="task"
							relatedEntity="tasks"
							relatedEntityId={task.id}
							wysiwygCanMention={true}
							readOnly
						/>
					</Box>
				)}
			</Box>
		</Box>
	);
};
